export default function search(){
    let desktopSearch = document.getElementById("desktopToggleSearch");

    if(desktopSearch){
        desktopSearch.addEventListener("click", toggleSearch);
        function toggleSearch(){
            var element = document.getElementById("searchInput")
            element.classList.toggle("active");
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        const modalSearch = document.querySelector(".modal-search");
        const searchElement = document.querySelector(".desktop-menu .search");
    
        // Função para verificar e atualizar a visibilidade
        function updateVisibility() {
            if (modalSearch.classList.contains("is-visible")) {
                searchElement.style.display = "opacity: 0";
            } else {
                searchElement.style.display = "";
            }
        }
    
        // Observador para detectar mudanças na classe da modal-search
        const observer = new MutationObserver(updateVisibility);
        observer.observe(modalSearch, { attributes: true, attributeFilter: ["class"] });
    });
}
